/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *******************************************************************************/

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@mui/styles';
import { Button, Card, CardContent, Container, Divider } from '@mui/material';
import { Link } from 'react-router-dom'


const styles = makeStyles(theme => ({
    root: {
    },
    imageDotedDescp: {
        transition: 'transform .2s',
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block',
        "&:hover": {
            transform: 'scale(1.2)',

        }
    },
    sectionTitleBorder: {
        width: '50px',
        height: '2px',
        marginRight: 'auto',
        marginLeft: 'auto',
        backgroundColor: '#fb743e',

    },
    divinfoNavigation: {
        marginTop: '100px'
    },
    cardContent: {
        backgroundImage: `url("/assets/images/Logo/logo_transparent.png")` 
    }
}));


const CompanyServiceGeneral = () => {
    const classes = styles();

    return (
        <>
            <Grid item xs={12} sm={12} md={12}  >
                <Typography variant="h1" align="center" style={{ marginTop: '100px' }} paragraph>
                    Our Services
                </Typography>
                <div className={classes.sectionTitleBorder}></div>
                <div className={classes.divinfoNavigation}>
                    <Container className={classes.cardGrid} maxWidth="lg">
                        {/* End hero unit */}
                        <Grid container spacing={4}>
                            <Grid item xs={12} sm={6} md={6}>
                                <Card className={classes.cardService} >
                                    <CardContent className={classes.cardContent}>

                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                            DIGITAL TRANSFORMATION
                                        </Typography>
                                        <Divider className={classes.divider} style={{ margin: '40px' }} />

                                        <Typography className={classes.blocksTypoInfo} variant="h3" align="center">


                                            <img src="assets/images/icons/web-analysis.png" width="100px" />
                                        </Typography>

                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                            Web  Deveopment
                                        </Typography>


                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                            Mobile  Deveopment
                                        </Typography>
                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                           Digital Strategy
                                        </Typography>
                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                           etc
                                        </Typography>
                                        <Button
                                            component={Link}
                                            to="/services"
                                            variant="contained"
                                            className="AlignCenter"
                                        >
                                            Learn More
                                        </Button>
                                    </CardContent>

                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <Card className={classes.cardService} >
                                    <CardContent className={classes.cardContent}>


                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                            CONSULTING
                                        </Typography>
                                        <Divider className={classes.divider} style={{ margin: '40px' }} />

                                        <Typography className={classes.blocksTypoInfo} variant="h3" align="center">
                                            <img src="assets/images/icons/consultation.png" width="100px" />
                                        </Typography>



                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                            Operational Performance
                                        </Typography>


                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                            Project Management
                                        </Typography>
                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                            Customer Relationship Management
                                        </Typography>
                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                           etc
                                        </Typography>
                                        <Button
                                            component={Link}
                                            to="/services"
                                            variant="contained"
                                            className="AlignCenter"
                                        >
                                            Learn More
                                        </Button>
                                    </CardContent>

                                </Card>
                            </Grid>

                        </Grid>
                    </Container>
                </div>
            </Grid>
        </>
    );
}


export default CompanyServiceGeneral;